// extracted by mini-css-extract-plugin
export default {"root":"SellerInfoExpanded-module-root","blink":"SellerInfoExpanded-module-blink","contentWrapper":"SellerInfoExpanded-module-contentWrapper"};